import { BRAND_ICON_DATA } from "./brand-icon-data";

// Source-owned SVG registry. Every entry contains the genuine vector path and
// its upstream source URL; consumers resolve aliases in BrandIcon.
export const BRAND_SVG_REGISTRY = BRAND_ICON_DATA;

export const EXTERNAL_INTEGRATION_BRANDS = [
  "x",
  "telegram",
  "apple",
  "notion",
] as const;
